import React from 'react';
export function ExitIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 4a1 1 0 00-1 1v3a1 1 0 01-2 0V5a3 3 0 013-3h11a3 3 0 013 3v14a3 3 0 01-3 3H8a3 3 0 01-3-3v-3a1 1 0 112 0v3a1 1 0 001 1h11a1 1 0 001-1V5a1 1 0 00-1-1H8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 12a1 1 0 011-1h11.586l-2.293-2.293a1 1 0 011.414-1.414l3.997 3.996a1.005 1.005 0 010 1.422l-3.997 3.996a1 1 0 01-1.414-1.414L14.586 13H3a1 1 0 01-1-1z"
  }));
}